import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faChevronCircleLeft, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

// Toast setup
const Toast = Swal.mixin({
  toast: true,
  position: "top-right",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const TransactionEntry = ({ accessOfDepartments }) => {
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [events, setEvents] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const sewadarId = localStorage.getItem("sewadarId");
  const code = localStorage.getItem("code");
  const token = localStorage.getItem("token");
  const navigate = useNavigate()
  const location = useLocation()
  const editId = location.state?.id
  const [headerData, setHeaderData] = useState({
    date: null,
    event: null,
    department: null,
    location: null,
    status: null,
    transaction: null,
    remarks: "",
  });
  const [rows, setRows] = useState([
    {
      id: 1,
      transDate: null,
      item: null,
      qty: "",
      consumptionType: null,
      vehicleOrLocation: null,
      remarks: null
    },
  ]);

  const statusOptions = [
    { value: "As Stock", label: "As Stock" },
    { value: "Installed/Fitted with Structure", label: "Installed/Fitted with Structure" },
    { value: "Installed/Fitted with Machinery", label: "Installed/Fitted with Machinery" },
    { value: "Installed/Fitted with Construction", label: "Installed/Fitted with Construction" },
    { value: "Installed/Fitted underground", label: "Installed/Fitted underground" },
    { value: "Installed/Fitted above roof", label: "Installed/Fitted above roof" },
    { value: "Installed/Fitted under shed", label: "Installed/Fitted under shed" },
    { value: "Installed/Fitted above shed", label: "Installed/Fitted above shed" },
    { value: "Dormant Stock", label: "Dormant Stock" },
    { value: "Office Inventory", label: "Office Inventory" },
    { value: "As Condemnation Stock", label: "As Condemnation Stock" },
  ];

  const transactionOptions = [
    { value: "Regular", label: "Regular" },
    { value: "Visit", label: "Visit" },
    { value: "AHQ", label: "AHQ" },
  ];

  const consumptionTypeOptions = [
    { value: "Vehicle", label: "Vehicle" },
    { value: "Machine", label: "Machine" },
    { value: "Generator", label: "Generator" },
  ];
  const fetchDraftData = async () => {
    if (editId) {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getTransactionEntry/${editId}`);
        const p = response.data;   // p = payload  
        // --- SET HEADER DATA (value-label format) ---
        setHeaderData({
          date: p?.date ? moment(p.date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
  
          event: p?.event
            ? {
                value: p.event,
                label: `[ ${p.eventType} ] ${p.event}`,
                type:p.eventType
              }
            : null,
  
          department: p?.department
            ? {
                value: p.department,
                label: p.department,
              }
            : null,
  
          status: p?.status
            ? {
                value: p.status,
                label: p.status,
              }
            : null,
  
          location: p?.location
            ? {
                value: p.location,
                label: p.location,
              }
            : null,
  
          transaction: p?.transactionType
            ? {
                value: p.transactionType,
                label: p.transactionType,
              }
            : null,
  
          remarks: p?.remarks || "",
        });
  
        // --- SET ROWS ---
        if (Array.isArray(p.items) && p.items.length > 0) {

          const mappedRows = p.items.map((item, index) => ({
            id: index + 1,
            transDate: item.transactionDate
              ? moment(item.transactionDate).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
  
            // if items also use select boxes, convert them
            item: item.itemName
              ? { value: item.itemName, label: item.itemName, itemId:item.itemId, uom:item.uom }
              : null,
  
            qty: item.qty || "",
  
            consumptionType: item.consumptionType
              ? { value: item.consumptionType, label: item.consumptionType }
              : null,
  
            vehicleOrLocation: item.allocation
              ? { value: item.allocation, label: item.allocation }
              : null,
  
            remarks: item.remarks || null,
          }));
  
          setRows(mappedRows);
        }
  
      } catch (err) {
        console.error(err.response?.data?.message || "Error fetching draft data");
      }
    }
  };
  
  useEffect(() => {
    fetchDraftData();
  }, [editId]);
  // ---------------- FETCH VEHICLES ----------------
  const fetchVehicleDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getVehicleDetails`);
      const options = response.data.map((v) => ({
        value: v.vehicleNo,
        label: v.vehicleNo,
      }));
      setVehicleOptions(options);
    } catch (error) {
      console.error("Vehicle fetch error", error);
    }
  };

  useEffect(() => {
    fetchVehicleDetails();
  }, []);

  // ---------------- CHANGE HEADER DATA ----------------
  const handleHeaderChange = (field, value) => {
    setHeaderData({ ...headerData, [field]: value });
  };

  // ---------------- DEPARTMENTS FROM PROPS ----------------
  useEffect(() => {
    if (accessOfDepartments) {
      const deptArray = accessOfDepartments
        .split(",")
        .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
      setDepartments(deptArray);
    }
  }, [accessOfDepartments]);

  // ---------------- FETCH LOCATIONS ----------------
  const fetchLocations = () => {
    apiClient
      .get(`${SERVER_BASE}/getLocations`, {
        params: { code },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) =>
        setLocations(
          res.data.map((loc) => ({
            value: loc.location,
            label: loc.location,
          }))
        )
      )
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  // ---------------- FETCH EVENTS ----------------
  const fetchEvents = async () => {
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/getpurposesInventoryByApplicability`,
        {
          params: { code, applicableOn: "Major Center" },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setEvents(
        res.data.map((p) => ({
          value: p.purposeName,
          label: `[ ${p.purposeType} ] ${p.purposeName}`,
          type: p.purposeType
        }))
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // ---------------- FETCH ITEMS ----------------
  const fetchItemOptions = async (deptArray) => {
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/getItemOptionsByDepartment`,
        {
          params: {
            code,
            accessOfDepartments: deptArray.join(","),
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setItemOptions(
        res.data.map((item) => ({
          value: item.printName,
          itemId: item.id,
          label: `${item.printName} ${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ""
            }`,
          itemCode: item.itemCode,
          uom: item.uom,
          unit: item.unit,
        }))
      );
    } catch (error) {
      console.error("Item fetch error:", error);
    }
  };

  useEffect(() => {
    if (headerData.department) {
      const deptArray = [headerData.department.value];
      fetchItemOptions(deptArray);
    }
  }, [headerData.department]);

  // ---------------- ROW HANDLERS ----------------
  const addRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        transDate: null,
        item: null,
        qty: "",
        consumptionType: null,
        vehicleOrLocation: null,
      },
    ]);
  };

  const removeRow = (index) => {
    if (rows.length > 1) {
      const updated = [...rows];
      updated.splice(index, 1);
      setRows(updated);
    }
  };

  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    if (field === "consumptionType") {
      updated[index].vehicleOrLocation = null;
    }

    setRows(updated);
  };

  const isConsumptionEvent =
    headerData.event?.value === "Consumption of Petrol" ||
    headerData.event?.value === "Consumption of Diesel";

  // ------------------------------------------------------------
  // ----------------------- SAVE HANDLER ------------------------
  // ------------------------------------------------------------
  const handleSave = async () => {
    // ---------------------- VALIDATIONS ----------------------
    if (!headerData.date)
      return Toast.fire({ icon: "error", title: "Please enter Date" });
    if (!headerData.event)
      return Toast.fire({ icon: "error", title: "Please select Event" });
    if (!headerData.department)
      return Toast.fire({ icon: "error", title: "Please select Department" });
  
    if (!headerData.location)
      return Toast.fire({ icon: "error", title: "Please select Location" });
  
    if (!headerData.status)
      return Toast.fire({ icon: "error", title: "Please select Status" });
  
    if (!headerData.transaction)
      return Toast.fire({ icon: "error", title: "Please select Transaction" });
  
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
  
      if (!r.transDate)
        return Toast.fire({
          icon: "error",
          title: `Row ${i + 1}: Transaction Date required`,
        });
  
      if (!r.item)
        return Toast.fire({
          icon: "error",
          title: `Row ${i + 1}: Item required`,
        });
  
      if (!r.qty || Number(r.qty) <= 0)
        return Toast.fire({
          icon: "error",
          title: `Row ${i + 1}: Quantity required`,
        });
  
      if (isConsumptionEvent) {
        if (!r.consumptionType)
          return Toast.fire({
            icon: "error",
            title: `Row ${i + 1}: Select Consumption Type`,
          });
  
        if (!r.vehicleOrLocation)
          return Toast.fire({
            icon: "error",
            title:
              r.consumptionType.value === "Vehicle"
                ? `Row ${i + 1}: Select Vehicle`
                : `Row ${i + 1}: Select Location`,
          });
      }
    }
  
    // ---------------------- BUILD PAYLOAD ----------------------
    const payload = {
      header: {
        date: headerData.date,
        event: headerData.event.value,
        eventType: headerData.event.type,
        department: headerData.department.value,
        location: headerData.location.value,
        status: headerData.status.value,
        transactionType: headerData.transaction.value,
        remarks: headerData.remarks,
        code,
        createdBy: sewadarId,
        voucherStatus: "Draft",
      },
  
      items: rows.map((r) => ({
        transactionDate: r.transDate,
        itemId: r.item.itemId,
        itemName: r.item.value,
        qty: r.qty,
        uom: r.item.uom,
        consumptionType: isConsumptionEvent ? r.consumptionType?.value : null,
        allocation: isConsumptionEvent ? r.vehicleOrLocation?.value : null,
        remarks: r.remarks,
      })),
    };
  
    // ---------------------- API CALL ----------------------
    try {
      if (editId) {
        // ---------- UPDATE ----------
        await apiClient.put(
          `${SERVER_BASE}/updateTransactionEntry/${editId}`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
  
        Toast.fire({
          icon: "success",
          title: "Transaction Updated Successfully!",
        });
      } else {
        // ---------- CREATE ----------
        await apiClient.post(`${SERVER_BASE}/saveTransactionEntry`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        Toast.fire({
          icon: "success",
          title: "Transaction Saved Successfully!",
        });
      }
  
      navigate(-1);
  
      // Reset fields only when it's NOT editId
      if (!editId) {
        setHeaderData({
          date: moment().format("YYYY-MM-DD"),
          event: null,
          department: null,
          location: null,
          status: null,
          transaction: null,
          remarks: "",
        });
  
        setRows([
          {
            id: 1,
            transDate: moment().format("YYYY-MM-DD"),
            item: null,
            qty: "",
            consumptionType: null,
            vehicleOrLocation: null,
          },
        ]);
      }
    } catch (error) {
      console.error("Save/Update failed:", error);
      Toast.fire({
        icon: "error",
        title: editId
          ? "Error updating transaction"
          : "Error saving transaction",
      });
    }
  };
  

  return (
    <div className="formcontainer mt-5">
      <div className="d-flex align-items-end mb-3">
        <button
          className="btn btn-secondary btn-sm me-3"
          onClick={() => navigate('../TransactionEntryList')}
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
        </button>
        <h5 className="mb-0">Event Transactions</h5>
      </div>

      {/* ---------------- HEADER SECTION ---------------- */}
      <div className="mb-4">
        <div className="row mb-3">
          <div className="col-md-2">
            <label className="form-label">Date</label>
            <input type="date" className="form-control" value={headerData.date} onChange={(e) => handleHeaderChange("date", e.target.value)}/>
          </div>

          <div className="col-md-4">
            <label className="form-label">Event</label>
            <Select
              options={events}
              value={headerData.event}
              onChange={(v) => handleHeaderChange("event", v)}
              formatOptionLabel={(option) => (
                <div>
                  <span
                    style={{
                      color: option.type === "Add" ? "green" : "red",
                      fontWeight: 600,
                    }}
                  >
                    [ {option.type} ]
                  </span>
                  &nbsp;
                  <span>{option.value}</span>
                </div>
              )}
            />

          </div>

          <div className="col-md-3">
            <label className="form-label">Department</label>
            <Select
              options={departments}
              value={headerData.department}
              onChange={(v) => handleHeaderChange("department", v)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Location</label>
            <Select
              options={locations}
              value={headerData.location}
              onChange={(v) => handleHeaderChange("location", v)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Status</label>
            <Select
              options={statusOptions}
              value={headerData.status}
              onChange={(v) => handleHeaderChange("status", v)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Transaction</label>
            <Select
              options={transactionOptions}
              value={headerData.transaction}
              onChange={(v) => handleHeaderChange("transaction", v)}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Remarks</label>
            <input
              type="text"
              className="form-control"
              value={headerData.remarks}
              onChange={(e) => handleHeaderChange("remarks", e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* ---------------- ITEMS SECTION ---------------- */}
      <div className="border rounded p-3">
        {/* LABELS */}
        <div className="row mb-2">
          <div className="col-md-2">Transaction Date</div>
          <div className="col-md-3">Item</div>
          <div className="col-md-1">Qty</div>
          <div className="col-md-1">UOM</div>

          {isConsumptionEvent && (
            <>
              <div className="col-md-2">Consumption Type</div>
              <div className="col-md-2">Vehicle / Location</div>
            </>
          )}
          {!isConsumptionEvent && (
            <>
              <div className="col-md-4">Remarks</div>
              <div className="col-md-1">Actions</div>
            </>)}
        </div>

        {/* ROWS */}
        {rows.map((row, index) => (
          <div className="row mb-3 align-items-end" key={row.id}>
            <div className="col-md-2">
              <input
                type="date"
                className="form-control"
                value={row.transDate}
                onChange={(e) => updateRow(index, "transDate", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <Select
                options={itemOptions}
                value={row.item}
                onChange={(v) => updateRow(index, "item", v)}
              />
            </div>

            <div className="col-md-1">
              <input
                type="text"
                className="form-control"
                value={row.qty}
                onChange={(e) => updateRow(index, "qty", e.target.value)}
              />
            </div>

            <div className="col-md-1">
              <input
                type="text"
                className="form-control"
                value={row.item?.uom || ""}
                readOnly
              />
            </div>

            {isConsumptionEvent && (
              <>
                <div className="col-md-2">
                  <Select
                    options={consumptionTypeOptions}
                    value={row.consumptionType}
                    onChange={(v) => updateRow(index, "consumptionType", v)}
                  />
                </div>


                <div className="col-md-2">
                  {row.consumptionType?.value === "Vehicle" ? (
                    <Select
                      options={vehicleOptions}
                      value={row.vehicleOrLocation}
                      onChange={(v) => updateRow(index, "vehicleOrLocation", v)}
                    />
                  ) : row.consumptionType ? (
                    <Select
                      options={locations}
                      value={row.vehicleOrLocation}
                      onChange={(v) => updateRow(index, "vehicleOrLocation", v)}
                    />
                  ) : null}
                </div>
              </>
            )}
            <div className="col-md-4 mt-3">
              {/* <label className="small">Remarks</label> */}
              <input
                type="text"
                className="form-control"
                value={row.remarks || ""}
                onChange={(e) => updateRow(index, "remarks", e.target.value)}
                placeholder="Remarks"
              />
            </div>
            <div className="col-md-1 d-flex gap-1">
              <button className="btn btn-success btn-sm w-50" onClick={addRow}>
                <FontAwesomeIcon icon={faAdd} />
              </button>

              <button
                className="btn btn-danger btn-sm w-50"
                disabled={rows.length === 1}
                onClick={() => removeRow(index)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="mt-3 text-end">
        <button className="btn btn-success" onClick={handleSave}>
          Save Transaction
        </button>
      </div>
    </div>
  );
};

export default TransactionEntry;
